import { queryClient } from '@/config/queryClient';

export const invalidateSystems = async () => {
  await queryClient.invalidateQueries({ queryKey: ['systems'] });
};
